<template>
  <div class="swiper mySwiper2" v-loading="loading">
    <div class="swiper-wrapper">
      <div
        class="swiper-slide"
        v-for="(item, index) in publicationDataList"
        :key="item.id || index"
      >
        <div
          ref="swiperCard"
          class="swiper_card"
          :style="cardStyle(item)"
          @click="openDetile(item)"
        >
          <!-- 移动端标题显示 -->
          <div class="slide-box-small3-phone" v-if="isMobile">
            <div class="slide-box-small3-phone-text">{{ item.title }}</div>
          </div>
          <!-- PC端悬浮遮罩 -->
          <div class="overlay" v-else>
            {{ item.title }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getnewList } from "../../api/resouces";
import Swiper from 'swiper';

export default {
  name: 'SwiperPublic',

  data() {
    return {
      windowWidth: 0,
      divHeight: 0,
      publicationDataList: [],
      titleTree: null,
      pid: '',
      swiper: null,
      loading: true,
      resizeTimer: null, // 防抖定时器
    };
  },

  computed: {
    // 是否为移动端
    isMobile() {
      return this.windowWidth < 800;
    },
  },

  mounted() {
    this.initWindowWidth();
    this.addResizeListener();
    this.getPublicationList();
  },

  beforeDestroy() {
    this.cleanup();
  },

  methods: {
    /**
     * 初始化窗口宽度
     */
    initWindowWidth() {
      this.windowWidth = document.documentElement.clientWidth;
    },

    /**
     * 添加窗口大小监听器
     */
    addResizeListener() {
      this.handleResizeDebounced = this.debounce(this.handleResize, 200);
      window.addEventListener('resize', this.handleResizeDebounced);
    },

    /**
     * 上一页（供父组件调用）
     */
    next1() {
      if (this.swiper) {
        this.swiper.slidePrev();
      }
    },

    /**
     * 下一页（供父组件调用）
     */
    next2() {
      if (this.swiper) {
        this.swiper.slideNext();
      }
    },

    /**
     * 移除窗口大小监听器
     */
    removeResizeListener() {
      if (this.handleResizeDebounced) {
        window.removeEventListener('resize', this.handleResizeDebounced);
      }
    },

    /**
     * 防抖函数
     */
    debounce(func, wait) {
      return (...args) => {
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(() => {
          func.apply(this, args);
        }, wait);
      };
    },

    /**
     * 处理窗口大小变化
     */
    handleResize() {
      this.windowWidth = document.documentElement.clientWidth;

      if (this.$refs.swiperCard && this.$refs.swiperCard[0]) {
        const width = this.$refs.swiperCard[0].offsetWidth;
        this.divHeight = width * 1.4143; // 书本比例
      }
    },

    /**
     * 计算卡片样式
     */
    cardStyle(item) {
      return {
        height: `${this.divHeight}px`,
        backgroundImage: `url(${item.Img})`,
      };
    },

    /**
     * 获取出版物列表
     */
    async getPublicationList() {
      try {
        this.loading = true;
        this.publicationDataList = [];

        const locale = this.$i18n.locale;
        const classIds = locale === 'zh' ? [36] : [84, 74];

        // 并行请求所有分类数据
        const promises = classIds.map(classId =>
          getnewList({ classId }).then(res => this.processPublicationData(res.data))
        );

        await Promise.all(promises);

        // 等待DOM更新后初始化Swiper
        this.$nextTick(() => {
          this.initSwiper();
          this.handleResize();
        });

      } catch (error) {
        console.error('获取出版物列表失败:', error);
        this.$message.error('加载出版物数据失败，请稍后重试');
      } finally {
        this.loading = false;
      }
    },

    /**
     * 处理出版物数据
     */
    processPublicationData(data) {
      if (!Array.isArray(data)) return;

      data.forEach(item => {
        if (item.Img) {
          item.Img = item.Img.replace(/\/upload/g, `${this.$urlFile}/upload`);
          this.publicationDataList.push(item);
        }
      });
    },

    /**
     * 初始化Swiper
     */
    initSwiper() {
      if (this.swiper) {
        this.swiper.destroy(true, true);
      }

      try {
        var self = this;
        this.swiper = new Swiper(".mySwiper2", {
          slidesPerView: 4,
          spaceBetween: 10,
          autoplay: {
            delay: 3000,
            disableOnInteraction: false,
          },
          loop: false,
          breakpoints: {
            // 响应式断点
            320: {
              slidesPerView: 2,
              spaceBetween: 5,
            },
            640: {
              slidesPerView: 3,
              spaceBetween: 8,
            },
            1024: {
              slidesPerView: 4,
              spaceBetween: 10,
            },
          },
          on: {
            init: function() {
              // Swiper初始化完成
              self.handleResize();
            },
          },
        });
      } catch (error) {
        console.error('初始化Swiper失败:', error);
      }
    },

    /**
     * 打开详情页
     */
    openDetile(info) {
      if (!info || !info.classId) {
        console.warn('无效的出版物信息');
        return;
      }

      const pid = this.getPid(info.classId);

      this.$router.push({
        path: '/detail',
        query: {
          pid,
          id: info.classId,
          detailId: info.id,
        },
      });
    },

    /**
     * 获取父级ID
     */
    getPid(classId) {
      try {
        const titleTreeData = sessionStorage.getItem('titleTree');
        if (!titleTreeData) {
          console.warn('未找到titleTree数据');
          return '';
        }

        this.titleTree = JSON.parse(titleTreeData);

        if (!this.titleTree.children) {
          return '';
        }

        // 递归查找pid
        const findPid = (children, targetId) => {
          for (const item of children) {
            if (item.children && item.children.length > 0) {
              for (const child of item.children) {
                if (child.data.id === targetId) {
                  return child.data.columnPid;
                }

                if (child.children) {
                  for (const grandChild of child.children) {
                    if (grandChild.data.id === targetId) {
                      return grandChild.data.columnPid;
                    }
                  }
                }
              }
            }
          }
          return '';
        };

        return findPid(this.titleTree.children, classId);

      } catch (error) {
        console.error('获取pid失败:', error);
        return '';
      }
    },

    /**
     * 清理资源
     */
    cleanup() {
      // 销毁Swiper实例
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }

      // 移除事件监听器
      this.removeResizeListener();

      // 清除定时器
      if (this.resizeTimer) {
        clearTimeout(this.resizeTimer);
      }
    },
  },
};
</script>

<style scoped>
/* Swiper容器 */
.swiper {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
}

/* Swiper幻灯片 */
.swiper-slide {
  text-align: center;
  font-size: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: transform 300ms ease;
}

/* 卡片容器 */
.swiper_card {
  width: 100%;
  position: relative;
  cursor: pointer;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  overflow: hidden;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.swiper_card:hover {
  transform: translateY(-4px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
}

/* PC端悬浮遮罩层 */
.overlay {
  position: absolute;
  bottom: -100%;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.75);
  color: #fff;
  text-align: center;
  padding: 12px 10px;
  font-size: 14px;
  line-height: 1.4;
  transition: bottom 0.3s ease-out;
  word-wrap: break-word;
}

.swiper_card:hover .overlay {
  bottom: 0;
}

/* 移动端标题显示 */
.slide-box-small3-phone {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 8px;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.8), transparent);
  display: flex;
  align-items: center;
  justify-content: center;
}

.slide-box-small3-phone-text {
  width: 90%;
  text-align: center;
  font-size: 12px;
  font-weight: 500;
  color: #fff;
  line-height: 1.3;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Swiper容器定位 */
.mySwiper2 {
  position: relative;
}

/* 响应式设计 */
@media screen and (max-width: 1024px) {
  .overlay {
    font-size: 12px;
    padding: 10px 8px;
  }
}

@media screen and (max-width: 640px) {
  .slide-box-small3-phone-text {
    font-size: 10px;
  }

  .swiper_card {
    border-radius: 2px;
  }
}

@media screen and (max-width: 320px) {
  .slide-box-small3-phone-text {
    font-size: 8px;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/carousel/swiper_public.vue